document.addEventListener('DOMContentLoaded', function () {
    const checkoutAddons = document.getElementById('checkoutAddonsDiv');
    const checkoutAddonsOverlay = document.getElementById('checkoutAddons');
    const closeBtn = document.getElementById('closeCheckoutAddons');
    const body = document.body;

    // Initially hide the CartDrawer checkout button
    const checkoutBtn = document.getElementById('CartDrawer-Checkout');
    if (checkoutBtn) {
        checkoutBtn.style.display = 'none';
    }
    const openBtn = document.getElementById('openCheckoutBtn');
    if (openBtn.style.display = 'none') {
        checkoutBtn.style.display = 'block';
    }

    // Move overlays to body
    if (checkoutAddonsOverlay && checkoutAddons) {
        body.appendChild(checkoutAddonsOverlay);
        body.appendChild(checkoutAddons);
    }

    function openCheckoutAddons() {
        if (checkoutAddons && checkoutAddonsOverlay) {
            checkoutAddons.style.display = 'block';
            checkoutAddonsOverlay.classList.add('activeCheckout');
        }

        const openBtn = document.getElementById('openCheckoutBtn');
        if (openBtn) openBtn.style.display = 'none';

        const checkoutBtn = document.getElementById('CartDrawer-Checkout');
        if (checkoutBtn) checkoutBtn.style.display = 'block';
    }

    function closeCheckoutAddons() {
        if (checkoutAddons && checkoutAddonsOverlay) {
            checkoutAddons.style.display = 'none';
            checkoutAddonsOverlay.classList.remove('activeCheckout');
        }
    }

    // Event delegation for dynamically added #openCheckoutBtn
    document.addEventListener('click', function (e) {
        const openBtn = e.target.closest('#openCheckoutBtn');
        if (openBtn) {
            e.stopPropagation();
            openCheckoutAddons();
            return;
        }

        // Close if clicking outside the popup
        if (
            checkoutAddons &&
            checkoutAddonsOverlay &&
            !checkoutAddons.contains(e.target)
        ) {
            closeCheckoutAddons();
        }
    });

    // Close button
    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            closeCheckoutAddons();
        });
    }

    // Prevent closing when clicking inside the popup
    if (checkoutAddons) {
        checkoutAddons.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    }

    // OPTIONAL: MutationObserver to re-bind if DOM updates cart drawer
    const cartDrawer = document.querySelector('#CartDrawer'); // adjust selector if needed
    if (cartDrawer) {
        const observer = new MutationObserver(() => {
            // Restore correct button state if cart content changes
            const openBtn = document.getElementById('openCheckoutBtn');
            const checkoutBtn = document.getElementById('CartDrawer-Checkout');

            if (openBtn && openBtn.style.display !== 'none') {
                if (checkoutBtn) checkoutBtn.style.display = 'none';
            }
        });

        observer.observe(cartDrawer, {
            childList: true,
            subtree: true,
        });
    }
});